import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiErrorHandler } from '../../../errors/api-error-handler';
import { BooksTabsInitialStateType, BooksTabsType } from '../../../models/education/books-tabs-model';
import BooksTabsService from '../../../services/education/books-tabs.service';

const initialState: BooksTabsInitialStateType = {
    BooksTabsData: [],
    BooksTabsLoading: true,
    BooksTabsError: undefined
};

type queryparamsType = {
    path: string
    pageNumber: number
}

export const retrieveBooksTabs = createAsyncThunk('BooksTabs/retrieve',
    async (queryparams:queryparamsType , { rejectWithValue }) => {
        try {

            const response = await BooksTabsService.getBooksTabs(queryparams.path, queryparams.pageNumber)
            return [response.data]

        } catch (error: any) {
            if (!error.response) {
                throw error
            }
            return rejectWithValue(error.response.status)
        }
    }
)

const BooksTabsSlice = createSlice({
    name: 'BooksTabs',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(retrieveBooksTabs.pending, (state) => {
                state.BooksTabsLoading = true;
            })
            .addCase(retrieveBooksTabs.fulfilled, (state, action) => {
                if (action.payload) {
                    state.BooksTabsLoading = false;
                    state.BooksTabsData = action.payload as BooksTabsType[];
                }
            })
            .addCase(retrieveBooksTabs.rejected, (state, { payload }) => {
                state.BooksTabsLoading = false;
                state.BooksTabsError = apiErrorHandler(Number(payload))
            })
    }
})

export const selectAllEntities = (state: { entities: any; }) => state.entities;
export default BooksTabsSlice.reducer;
